import { useEffect, useState } from "react";
import { ApolloError } from "@apollo/client";
import { CompanyQuery, useCompanyLazyQuery } from "@/generated/graphql_billing";

export function useFetchBillingCompany() {
  const [fetchCompany, { loading, error, data }] = useCompanyLazyQuery({
    context: {
      api: "billing",
    },
  });
  const [companyResult, setCompanyResult] = useState<CompanyQuery | null>(null);
  const [companyError, setCompanyError] = useState<ApolloError | null>(null);

  useEffect(() => {
    if (!loading) {
      if (!error && data) {
        setCompanyResult(data);
      } else if (error && !data) {
        setCompanyError(error);
      }
    }
  }, [loading, error, data]);

  return { companyResult, companyError, fetchCompany };
}
